/**
 * @fileoverview POST handler for the "/engagement/conversion_report" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementConversionReportCacheKeys } from "./constants";
import type { PostEngagementConversionReportProps, PostEngagementConversionReportResult } from "./types";

export const postEngagementConversionReport = reactQueryMutationAdapter(
  engagementConversionReportCacheKeys,
  (props: PostEngagementConversionReportProps): Promise<PostEngagementConversionReportResult> => {
    return fetch("/engagement/conversion_report", "POST", props, {}, { propagateFetchRequestError: false });
  }
);
